document.addEventListener("DOMContentLoaded", () => {
    const sliders = document.querySelectorAll('.wp-block-kaloncom-background-slider');

    sliders.forEach(slider => {
        const images = slider.querySelectorAll('.kaloncom-bg-slider__image');
        if (images.length < 2) return;

        const interval = parseInt(slider.dataset.interval, 10) || 5000;
        let currentIndex = 0;

        setInterval(() => {
            const currentImg = images[currentIndex];
            currentIndex = (currentIndex + 1) % images.length;
            const nextImg = images[currentIndex];

            // 1. L'image actuelle sort de l'écran
            currentImg.classList.remove('is-active');
            currentImg.classList.add('is-exiting');

            // 2. Retirer la classe de sortie de la prochaine image 
            // pour qu'elle reprenne sa position d'attente par défaut
            nextImg.classList.remove('is-exiting');
            
            // 3. LA MAGIE EST ICI : On force le navigateur à appliquer le CSS immédiatement.
            // Ça "téléporte" l'image à sa position de départ de façon invisible.
            void nextImg.offsetWidth;

            // 4. On fait entrer la nouvelle image
            nextImg.classList.add('is-active');

        }, interval);
    });
});